import { Component, Input } from "@angular/core";

@Component({
	selector: "app-progress-tile",
	templateUrl: "./progress-tile.component.html",
	styleUrls: ["./progress-tile.component.scss"],
})
export class ProgressTileComponent {
	@Input() title: string;
	@Input() lowerLimit: number;
	@Input() upperLimit: number;
	@Input() fixedPercentage: number;
	@Input() percentageValue1: number;
	@Input() percentageValue2: number;

	getPercentageValue(val1, val2) {
		return (val1 / (val1 + val2)) * 100;
	}
}
